export enum PlanItemTypeEnum {
    Person = 1,
    Place = 2,
}
